import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { ProjectImageData } from 'src/app/project/shared/interfaces/project-image-data.interface';
import { ProjectService } from 'src/app/project/shared/services/project.service';
import { SelectInput } from 'src/app/shared/dropdown/shared/select-input.class';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'avs-fallback-image-settings',
  templateUrl: './fallback-image-settings.component.html',
  styleUrls: ['./fallback-image-settings.component.css']
})
export class FallbackImageSettingsComponent implements OnInit {

  public anzeigeprinzip: number = 3;
  public stellcode: number = 0;
  public funktions: number = 0;
  public delay: number | null = null;
  /** false, wenn die Station/der Kanal keine Verzögerung kennt (Delay null): Feld wird nicht angeboten */
  public delayAvailable: boolean = false;
  public projectId: number = 0;
  public onFunctionSelected: boolean = true;

  public images: ProjectImageData[] = [];
  public selectedImage?: ProjectImageData;
  public preSelectedImage?: ProjectImageData;
  public allImages: ProjectImageData[] = [];
  protected readonly environment = environment;

  public isFunctionDropdownOpen: boolean = false;
  public functionSelect: SelectInput[] = [{ name: 'Aus', id: 0 }, { name: 'An', id: 1 }/* , { name: 'Blinkend', id: 2 } */];
  public selectedFunction: SelectInput = { name: "Funktion" };
  public imagesSet: boolean = false;
  dataEndChannel?: DataEndChannel;
  stellcodeNotFound: boolean = false;
  public isImageSelected = false;


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FallbackImageSettingsComponent>,
    private projectService: ProjectService) { }

  public ngOnInit(): void {
    this.dataEndChannel = this.data.data;
    let defaultSettings = JSON.parse(this.dataEndChannel?.defaultSettings!)
    let fallbackSettings = defaultSettings.FallbackSettings
    // null/fehlend = Verzögerung nicht konfiguriert: kein Feld, beim Speichern geht null zurück
    this.delayAvailable = fallbackSettings?.Delay !== undefined && fallbackSettings?.Delay !== null
    this.delay = this.delayAvailable ? fallbackSettings.Delay : null

    this.dataEndChannel?.defaultSettings
    this.projectId = this.data.projectId
    if (this.projectId !== 0) {
      this.projectService.getAllRouteStationImagesWithStationId(this.data.projectId, this.data.data.routeStationId).subscribe((images) => {
        this.allImages = images
        this.images = images;
        if (fallbackSettings) {
          this.preSelectedImage = this.images.find(image => image.stellcode === fallbackSettings.stellcode)
        if (this.preSelectedImage?.stellcode === fallbackSettings.stellcode && this.preSelectedImage) {
            this.onProjectImageClicked(this.preSelectedImage)
          }
       
        else { this.stellcodeNotFound = true; }
    
        if (fallbackSettings.indicator === 0) {
          this.onFunctionItemClicked({ name: 'Aus', id: 0 })
        }
        if (fallbackSettings.indicator === 1) {
          this.onFunctionItemClicked({ name: 'An', id: 1 })
        }
        this.imagesSet = true;
      }
      else
      {
        this.stellcodeNotFound = true;
        this.imagesSet = true;
      }
    });
    }
   
  }


  /** Verzögerung muss eine Ganzzahl zwischen 0 und 65535 Sekunden sein (UInt16 auf der Station); ohne Feld gibt es nichts zu prüfen. */
  public get isDelayValid(): boolean {
    if (!this.delayAvailable) { return true; }
    return this.delay !== null && Number.isInteger(this.delay) && this.delay >= 0 && this.delay <= 65535;
  }

  public onCloseDialogClicked(): void {
    this.dialogRef.close();
  }
  public onFunctionDropdownClicked(): void {
    this.isFunctionDropdownOpen = !this.isFunctionDropdownOpen;
  }

  public onProjectImageClicked(image: ProjectImageData) {

    if (this.isImageSelected) { this.images = this.allImages; this.isImageSelected = false; return }
    if (this.images) {
      if (this.images.length > 1) {
        this.selectedImage = image
        this.images = [];
        this.images.push(image)
        this.isImageSelected = true;

      }
      else if (this.images.length === 1) {
        this.selectedImage = image
        this.isImageSelected = true;
      }
    }
  }

  public onFunctionItemClicked(item: SelectInput): void {
    this.onFunctionSelected = false;
    this.isFunctionDropdownOpen = false;
    this.selectedFunction.name = item.name
    this.selectedFunction.id = item.id
    let funcId = item.id as number
  }

  public onSubmitBtnClicked(): void {
    this.stellcodeNotFound = false;
    this.isImageSelected = false;
    this.dialogRef.close({
      anzeigeprinzip: this.anzeigeprinzip,
      stellcode: this.selectedImage?.stellcode as number,
      indicator: this.selectedFunction.id as number,
      delay: this.delayAvailable ? this.delay : null
    });
  }
}
